var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M467 76H45C20.137 76 0 96.262 0 121V391C0 415.885 20.285 436 45 436H467C491.655 436 512 415.97 512 391V121C512 96.306 491.943 76 467 76ZM460.698 106C451.504 115.145 293.283 272.533 287.82 277.967C279.32 286.467 268.02 291.147 256 291.147C243.98 291.147 232.68 286.466 224.152 277.939C220.478 274.284 64.003 118.634 51.302 106H460.698ZM30 384.894V127.125L159.638 256.08L30 384.894ZM51.321 406L180.908 277.237L202.967 299.18C217.133 313.346 235.967 321.147 256 321.147C276.033 321.147 294.867 313.346 309.005 299.208L331.092 277.237L460.679 406H51.321ZM482 384.894L352.362 256.08L482 127.125V384.894Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e96ee94153fc8eae150411ede805bd5a.svg";
export { ForwardRef as ReactComponent };